import { Component } from "react";
import { signUp } from "../../utilities/users-service";

export default class SignUpForm extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    name: "",
    email: "",
    password: "",
    confirm: "",
    error: "",
  };

  handleChange = (evt) => {
    this.setState({
      [evt.target.name]: evt.target.value,
      error: "",
    });
  };

  handleSubmit = async (evt) => {
    evt.preventDefault();

    try {
      const { name, email, password } = this.state;
      const formData = { name, email, password };

      const user = await signUp(formData);
      this.props.setUser(user);
      this.props.navigate("/");
    } catch {
      this.setState({ error: "Sign up failed — try again" });
    }
  };

  render() {
    const disable = this.state.password !== this.state.confirm;
    const inputClasses =
      "w-full border-b border-gray-300 bg-transparent py-2 text-sm text-gray-900 placeholder-gray-400 outline-none transition-colors focus:border-gray-900";

    return (
      <div>
        <form
          autoComplete="off"
          onSubmit={this.handleSubmit}
          className="space-y-6"
        >
          <div>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={this.state.name}
              onChange={this.handleChange}
              required
              className={inputClasses}
            />
          </div>
          <div>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={this.state.email}
              onChange={this.handleChange}
              required
              className={inputClasses}
            />
          </div>
          <div>
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={this.state.password}
              onChange={this.handleChange}
              required
              className={inputClasses}
            />
          </div>
          <div>
            <input
              type="password"
              name="confirm"
              placeholder="Confirm password"
              value={this.state.confirm}
              onChange={this.handleChange}
              required
              className={inputClasses}
            />
          </div>
          <button
            type="submit"
            disabled={disable}
            className="w-full rounded-lg bg-gray-900 py-3 text-sm font-medium text-white transition-colors hover:bg-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Sign up
          </button>
        </form>
        {this.state.error && (
          <p className="mt-4 text-center text-xs text-red-500">
            {this.state.error}
          </p>
        )}
      </div>
    );
  }
}
